@if (isIcon()) {
  @if (isDispatched()) {
    <div [matTooltip]="tooltip()" [matTooltipClass]="'regular-tooltip'" matTooltipPosition="above">
      <mat-icon class="table-icon-content">local_shipping</mat-icon>
    </div>
  }
} @else {
  <!-- Used for Set Filter custom renderer (blanks / select all) -->
  <span>{{ value() }}</span>
}
